import { api } from '@/lib/api';
import type { CremationDetailsRequest, CremationDetailsResponse } from './types';

const URL = '/vendor/onboarding/module-details/cremation';

export async function save_cremation_details(
  input: CremationDetailsRequest,
): Promise<CremationDetailsResponse> {
  const res = await api.post<CremationDetailsResponse>(URL, input);
  return res.data;
}

export async function fetch_cremation_details(): Promise<CremationDetailsResponse | null> {
  const res = await api.get<CremationDetailsResponse | null>(URL);
  return res.data;
}
